import Swiper from 'swiper';

export default sliderMesh => {
    // console.log('sliderMesh');
    const swiperContainerMesh = sliderMesh.querySelector('.swiper-container');
    const swiperPaginationMesh = swiperContainerMesh.querySelector('.swiper-pagination');

    const slideSpace = sliderMesh.classList.contains('offers') ? 50 : 30;

    const meshSlider = new Swiper(swiperContainerMesh, {
        // init: false,
        //slidesPerView: 'auto',
        slidesPerView: 1,
        breakpoints: {
   
            // when window width is >= 480px
            768: {
              slidesPerView: 2,
           
            }
        },
     
        spaceBetween: slideSpace,
        grabCursor: true,
        pagination: {
            el: swiperPaginationMesh,
            clickable: true,
            renderBullet: (index, className) => `<button type="button" class="${className}"><span class="sr-only">${index + 1}</span></button>`,
        }
        // simulateTouch: false,
        // allowTouchMove: false,
        // on: {
        //     init: () => {
        //         console.log('simulateTouch', proximitySlider.params.simulateTouch);
        //         console.log('allowTouchMove', proximitySlider.params.allowTouchMove);
        //         console.log('grabCursor', proximitySlider.params.grabCursor);
        //         proximitySlider.params.simulateTouch = false;
        //         proximitySlider.params.allowTouchMove = false;
        //         proximitySlider.params.grabCursor = false;
        //         console.log('simulateTouch', proximitySlider.params.simulateTouch);
        //         console.log('allowTouchMove', proximitySlider.params.allowTouchMove);
        //         console.log('grabCursor', proximitySlider.params.grabCursor);
        //     },
        // },
    });

    // updateLegends();
    // parcoursSlider.on('init', updateLegends);
    // parcoursSlider.on('slideChange', updateLegends);

    // proximitySlider.on('init', () => {
    //     console.log('simulateTouch', proximitySlider.params.simulateTouch);
    //     console.log('allowTouchMove', proximitySlider.params.allowTouchMove);
    //     console.log('grabCursor', proximitySlider.params.grabCursor);
    //     // proximitySlider.params.simulateTouch = !(proximitySlider.slides.length < 4);
    //     // proximitySlider.params.allowTouchMove = !(proximitySlider.slides.length < 4);
    //     proximitySlider.params.simulateTouch = false;
    //     proximitySlider.params.allowTouchMove = false;
    //     proximitySlider.params.grabCursor = false;
    //     console.log('simulateTouch', proximitySlider.params.simulateTouch);
    //     console.log('allowTouchMove', proximitySlider.params.allowTouchMove);
    //     console.log('grabCursor', proximitySlider.params.grabCursor);
    // });

    // proximitySlider.init();
    // console.log('simulateTouch', proximitySlider.params.simulateTouch);
    // console.log('allowTouchMove', proximitySlider.params.allowTouchMove);
    // console.log('grabCursor', proximitySlider.params.grabCursor);
};
